import type { UiSchema } from '@rjsf/utils';
import type { JSONSchema7 } from 'json-schema';

export const schema = {
  type: 'object',
  properties: {
    agentid: { type: 'string', title: 'Agent ID' },
    phoneNumber: { type: 'string', title: 'Phone Number' },
    pin: { type: 'integer', title: 'PIN' },
  },
  required: ['agentid', 'phoneNumber', 'pin'],
  additionalProperties: false,
} satisfies JSONSchema7;

export const uiSchema = {
  agentid: {
    'ui:placeholder': 'Enter agent ID',
  },
  phoneNumber: {
    'ui:placeholder': 'Enter phone number',
  },
  pin: {
    'ui:placeholder': 'Enter PIN',
  },
} satisfies UiSchema;
